export default __webpack_public_path__ + "static/media/CNo.81-1.94611aa2.jpg";